import axios from 'axios';
import { SERVER_ENDPOINT, CLIENT_ID, CLIENT_SECRET } from '../Constants';

function getUserEvents(id, token) {
  const url = 'api/user/' + id + '/events/';
  return axios({
    method: 'get',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + token,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function getEvent(id, token) {
  const url = 'api/event/' + id + '/';
  return axios({
    method: 'get',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + token,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

// old one
function getEvents(
  lat,
  lng,
  trainer,
  beltLevel,
  startDate,
  endDate,
  page,
  pageSize,
) {
  const url = 'api/event/';
  return axios({
    method: 'get',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    params: {
      lat,
      lng,
      user: trainer,
      cert_level: beltLevel,
      start_date: startDate,
      end_date: endDate,
      page,
      page_size: pageSize,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

// new one
function getTrainings(
  attendanceType,
  lat,
  lng,
  eventType,
  trainer,
  timezone,
  day,
  language,
  ordering,
  page,
  pageSize,
  startDate,
  endDate,
) {
  const url = 'api/event/';
  return axios({
    method: 'get',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    params: {
      online: attendanceType,
      lat,
      lng,
      cert_level: eventType,
      user: trainer,
      timezone,
      day,
      start_date: startDate,
      end_date: endDate,
      language,
      ordering,
      page,
      page_size: pageSize,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function getOnlineEvents(
  trainer,
  beltLevel,
  startDate,
  endDate,
  startTime,
  endTime,
  day,
  timezone,
  page,
  pageSize,
) {
  const url = 'api/event/';
  return axios({
    method: 'get',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    params: {
      online: true,
      user: trainer,
      cert_level: beltLevel,
      start_date: startDate,
      end_date: endDate,
      start_time: startTime,
      end_time: endTime,
      day,
      timezone,
      page,
      page_size: pageSize,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function updateEvent(eventId, event, token) {
  const url = 'api/event/' + eventId + '/';
  return axios({
    method: 'put',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + token,
    },
    data: {
      location: event.location,
      event_type: event.event_type,
      language: event.language,
      online: event.online,
      link: event.link,
      timezone: event.timezone,
      active: event.active,
      start_date: event.start_date,
      end_date: event.end_date,

      monday: event.monday,
      monday_start: event.monday_start,
      monday_end: event.monday_end,
      tuesday: event.tuesday,
      tuesday_start: event.tuesday_start,
      tuesday_end: event.tuesday_end,
      wednesday: event.wednesday,
      wednesday_start: event.wednesday_start,
      wednesday_end: event.wednesday_end,
      thursday: event.thursday,
      thursday_start: event.thursday_start,
      thursday_end: event.thursday_end,
      friday: event.friday,
      friday_start: event.friday_start,
      friday_end: event.friday_end,
      saturday: event.saturday,
      saturday_start: event.saturday_start,
      saturday_end: event.saturday_end,
      sunday: event.sunday,
      sunday_start: event.sunday_start,
      sunday_end: event.sunday_end,

      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function createEvent(userId, event, token) {
  const url = 'api/event/';
  return axios({
    method: 'post',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + token,
    },
    data: {
      user: userId,
      location: event.location,
      event_type: event.event_type,
      language: event.language,
      online: event.online,
      link: event.link,
      timezone: event.timezone,
      active: event.active,
      start_date: event.start_date,
      end_date: event.end_date,

      monday: event.monday,
      monday_start: event.monday_start,
      monday_end: event.monday_end,
      tuesday: event.tuesday,
      tuesday_start: event.tuesday_start,
      tuesday_end: event.tuesday_end,
      wednesday: event.wednesday,
      wednesday_start: event.wednesday_start,
      wednesday_end: event.wednesday_end,
      thursday: event.thursday,
      thursday_start: event.thursday_start,
      thursday_end: event.thursday_end,
      friday: event.friday,
      friday_start: event.friday_start,
      friday_end: event.friday_end,
      saturday: event.saturday,
      saturday_start: event.saturday_start,
      saturday_end: event.saturday_end,
      sunday: event.sunday,
      sunday_start: event.sunday_start,
      sunday_end: event.sunday_end,

      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function deleteEvent(classId, token) {
  const url = 'api/event/' + classId + '/';
  return axios({
    method: 'delete',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + token,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}


export {
  getUserEvents,
  getEvent,
  getEvents,
  getTrainings,
  getOnlineEvents,
  updateEvent,
  createEvent,
  deleteEvent,
};
